/**
 * Soft Lock 개인 설정. 기준정보 화면은 이 문서 범위 밖 — 기본값 + localStorage 계약만.
 * 키는 추후 사용자 설정 테이블 컬럼과 맞춘다.
 */
const STORAGE_PREFIX = 'erp.screenLock';

export const SCREEN_LOCK_THEME = {
  MINIMAL_DARK: 'minimal-dark',
  TENANT_BRAND: 'tenant-brand',
};

/** 기본 유휴 5분. Hard Logout(60분)보다 짧게 둔다. */
export const DEFAULT_SCREEN_LOCK_TIMEOUT_SEC = 300;

export function defaultScreenLockSettings() {
  return {
    enabled: true,
    timeoutSec: DEFAULT_SCREEN_LOCK_TIMEOUT_SEC,
    theme: SCREEN_LOCK_THEME.MINIMAL_DARK,
  };
}

function storageKey(tenantCode, userId) {
  return [STORAGE_PREFIX, tenantCode || '', userId || ''].join('|');
}

export function loadScreenLockSettings(tenantCode, userId) {
  const defaults = defaultScreenLockSettings();
  try {
    const raw = localStorage.getItem(storageKey(tenantCode, userId));
    if (!raw) return defaults;
    const data = JSON.parse(raw);
    const theme = String(data.theme || '');
    const timeout = Number(data.timeoutSec);
    return {
      enabled: data.enabled !== false,
      timeoutSec: Number.isFinite(timeout) && timeout > 0 ? timeout : defaults.timeoutSec,
      theme: Object.values(SCREEN_LOCK_THEME).includes(theme) ? theme : defaults.theme,
    };
  } catch {
    return defaults;
  }
}
